export default "__VITE_ASSET__YCrujrQC__"